import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
const CustomFilter = ({ column, onFilterChange, uniqueValues, currentSelected }) => {
  return (
    <select onChange={(e) => onFilterChange(e.target.value)}>
      <option value="">All</option>
      {uniqueValues.map((value, index) =>
        value == currentSelected ? (
          <option key={index} value={value} selected>
            {value}
          </option>
        ) : (
          <option key={index} value={value}>
            {value}
          </option>
        ),
      )}
    </select>
  )
}

export default CustomFilter

CustomFilter.propTypes = {
  column: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  uniqueValues: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentSelected: PropTypes.string.isRequired,
}
